import React, { memo } from "react";
import { FaCircleDollarToSlot, FaMoneyCheckDollar } from "react-icons/fa6";
import { VscLayers } from "react-icons/vsc";
import styles from "../table.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { FaRegCircleCheck } from "react-icons/fa6";
import { setPaymentStatus } from "../../../../store/slices/tablePaidStatus";

const PaymentStatusTab = () => {
  const dispatch = useDispatch();
  const { paymentTabIndex } = useSelector((state) => state.tablePaidStatus);

  const paymentOptions = [
    { name: "All", icon: <VscLayers />, bgColor: "#369dc9" },
    { name: "PAID", icon: <FaMoneyCheckDollar />, bgColor: "#2bc155" },
    { name: "UNPAID", icon: <FaCircleDollarToSlot />, bgColor: "#ffb800" },
  ];

  return (
    <div className={styles.TabWrapper}>
      <div className={styles.TabContainer}>
        {paymentOptions?.map((item, index) => (
          <p
            key={index}
            className={styles.tab}
            onClick={async () => await dispatch(setPaymentStatus(index))}
            style={{ backgroundColor: item?.bgColor }}
          >
            {item?.icon} {item?.name}
            {paymentTabIndex === index && (
              <FaRegCircleCheck className={styles.check} />
            )}
          </p>
        ))}
      </div>
    </div>
  );
};

export default memo(PaymentStatusTab);
